export default function CochransQ() {
  // TODO
}



// WEBPACK FOOTER //
// ./src/NPairedSamples/CochransQ.js